import React, { useState, useEffect } from "react";
import user from "../../assets/user2.png";
import ig from "../../assets/instagram.png";
import like from "../../assets/like.png";
import comment from "../../assets/comment.png";
import share from "../../assets/share.png";
import '../App.css';

function InstaSecond({layout,testimonial,media,hashtag,name,profile,colorTheme,time}) {
  const [displayText, setDisplayText] = useState('');
  const [isValid, setIsValid] = useState(true);
  const [fade,setFade]=useState(false);

  useEffect(()=>{
    setTimeout(() => {
      setFade(true)
    }, time-1000);
  })

  useEffect(() => {
    let i = 0;
    const interval = setInterval(() => {
      if (i < testimonial.length) {
        const currentChar = testimonial.charAt(i);
        setDisplayText(prevText => prevText + currentChar);
        i++;
      } else {
        clearInterval(interval);
      }
    }, 20);
  
    return () => clearInterval(interval);
  }, [testimonial]);

  function getProxiedImageUrl(src) {
    try {
      const proxiedImageUrl = `https://api.allorigins.win/raw?url=${encodeURIComponent(src)}`;
      return proxiedImageUrl;
    }
    catch (error) { 
      console.error('Error occurred while generating proxied URL:', error);
      return null; 
    }
  }

  const handleImageError = () => {
    setIsValid(false);
  };
  const business = localStorage.getItem("BusinessName")
  return (
    layout === "Landscape"?(
    <div>
      <div
        className={`content-box-insta ${fade ? 'close-book' : ''}`}
        style={{
            position: "absolute",
            right: business==="Drive X Mobility "?"18vw":"10vw",
            top: "27vh",
            background: "white",
            height: "30vh",
            width: "35vw",
            maxHeight:"65vh",
            padding: "17px",
            borderRadius: "30px",
        }}
      >
        <div  style={{display:"flex",gap:"1vw"}}>
          <div style={{display:"flex",flexDirection:"column"}}>
        <div style={{ position: 'relative', display: 'inline-block' }}>
  <img
    src={media}
    className="profile-img"
    style={{
      width: '15vw',
      height: 'auto',
      transition: 'transform 1s ease-in-out'
    }}
  />
  <img
    src={ig}
    style={{
      position: 'absolute',
      top: '1vh',
      right: '0.5vw',
      width: '25px', // adjust this value as needed
      height: 'auto', // or set a fixed height if needed
      zIndex: 1 // ensure it's on top of the original image
    }}
  />
        </div>
        <div style={{display:"flex",gap:"1vw"}}>
          <img src={like} width={20}/>
          <img src={comment} width={20}/>
          <img src={share} width={20}/>
        </div>
</div>
      <div style={{display:"flex",flexDirection:"column",justifyContent:"space-between"}}>
      <p style={{ color: colorTheme?colorTheme:"#703484", fontWeight: "300", fontSize: "2.2vw", margin: "-1vh 0 1vh 0",fontStyle:"italic" }} className="animated-title">{hashtag&&"#"+hashtag}</p>
       <p style={{ color: "black", fontWeight: "400", margin: "2vh 0 0 0",fontSize:"1.4vw"  }} className="animated-first">{testimonial}</p>
      <div style={{display:"flex",gap:"0.5vw",justifyContent:"center",alignItems:"center"}}>
<img onError={handleImageError}
        src={profile&&isValid?getProxiedImageUrl(profile):user}
        className="profile-img"
        width={name?30:0}
        style={{
          height:"auto",
          borderRadius:"50%",
          border: "3px solid white",
          transition: "transform 1s ease-in-out"
        }}
      />
<p style={{ color:colorTheme?colorTheme:"#703484", fontWeight: "600", fontSize: "2vw", margin: "0" }} className="animated-text">{name?name:""}</p>
</div>
</div>
</div>
      </div>
    </div>
    ):(
      <div>
      <div
        className={`content-box-insta ${fade ? 'close-book' : ''}`}
        style={{
            position: "absolute",
            right: "8vw",
            top: "23vh",
            background: "white",
            height: "30vh",
            width: "80vw",
            maxHeight:"65vh",
            padding: "17px",
            borderRadius: "30px",
        }}
      >
        <div  style={{display:"flex",gap:"1vw"}}>
          <div style={{display:"flex",flexDirection:"column"}}>
        <div style={{ position: 'relative', display: 'inline-block' }}>
  <img
    src={media}
    className="profile-img"
    style={{
      width: '35vw',
      height: 'auto',
      transition: 'transform 1s ease-in-out'
    }}
  />
  <img
    src={ig}
    style={{
      position: 'absolute',
      top: '1vh',
      right: '1.5vw',
      width: '4vw', // adjust this value as needed
      height: 'auto', // or set a fixed height if needed
      zIndex: 1 // ensure it's on top of the original image
    }}
  />
        </div>
        <div style={{display:"flex",gap:"1vw"}}>
          <img src={like} width={25}/>
          <img src={comment} width={25}/>
          <img src={share} width={25}/>
        </div>
</div>
      <div style={{display:"flex",flexDirection:"column",justifyContent:"space-between"}}>
      <p style={{ color:colorTheme?colorTheme:"#703484", fontWeight: "300", fontSize: "5vw", margin: "-1vh 0 1vh 0",fontStyle:"italic" }} className="animated-title">{hashtag&&"#"+hashtag}</p>
       <p style={{ color: "black", fontWeight: "400", margin: "2vh 0 2vh 0",fontSize:"3vw"  }} className="animated-first">{testimonial}</p>
      <div style={{display:"flex",gap:"0.5vw",justifyContent:"center",alignItems:"center"}}>
<img onError={handleImageError}
        src={profile&&isValid?getProxiedImageUrl(profile):user}
        className="profile-img"
        width={name?30:0}
        style={{
          height:"auto",
          borderRadius:"50%",
          border: "3px solid white",
          transition: "transform 1s ease-in-out",
          width:"5vw"
        }}
      />
<p style={{ color:colorTheme?colorTheme:"#703484", fontWeight: "600", fontSize: "4vw", margin: "0" }} className="animated-text">{name?name:""}</p>
</div>
</div>
</div>
      </div>
    </div>
    )
  )
}

export default InstaSecond;
